import React, { useContext, useState, useEffect } from "react"
import { Form } from "semantic-ui-react"
import Panel from "../../../components/shared/Panel"
import PropTypes from 'prop-types'
import { useTextResources } from "../../../language"
import { DatePicker, TimePicker } from '../../../components/shared/DatePicker'
import NumericInput from '../../../components/shared/NumericInput'
import ReservationCategoriesDropDown from '../../../components/shared/ReservationCategoriesDropDown'
import ReservationContext from "../context"
import moment from 'moment'
import { RebuildReservation, RecalcReservationForFixedPricesPaxChange } from '../../../Utils/reservation'

export const DetailsPanel = ()=>{
    const text = useTextResources()
    const {reservation, setReservation} = useContext(ReservationContext)
    const [businessDate, setBusinessDate] = useState(new Date())

    useEffect(() => {
        setBusinessDate(new Date())
    }, [])

    const setEta = val => {
        setReservation({
            ...reservation,
            Eta: val
        })
    }
    const setEdt = val => {
        setReservation({
            ...reservation,
            Edt: val
        })
    }
    const setCheckInDate = val => {
        const updatedDates = recalcCheckInOutDates(val, reservation.CheckOutDate)
        RebuildReservation(reservation, updatedDates.checkInDate, updatedDates.checkOutDate)
        setReservation({ ...reservation })
        if (reservation.CheckOutDate < val) {
            setCheckOutDate(moment(val).add(1, "day").toDate())
        }
    }
    const setCheckOutDate = val => {
        const updatedDates = recalcCheckInOutDates(reservation.CheckInDate, val)
        RebuildReservation(reservation, updatedDates.checkInDate, updatedDates.checkOutDate)
        setReservation({ ...reservation })
    }
    const setAdults = val => {
        setReservationPax("Adults", val)
        setReservation({ ...reservation })
    }
    const setChildren = val => {
        setReservationPax("Children", val)
        setReservation({ ...reservation })
    }
    const setInfants = val => {
        setReservationPax("Infants", val)
        setReservation({ ...reservation })
    }
    const setReservationPax = (prop, val) => {
        val = Number(val)
        const delta = val - reservation[prop];
        reservation[prop] = val
        if (reservation.ReservationDailyAccommodations) {
            reservation.ReservationDailyAccommodations.forEach(accomodation => {
                accomodation[prop] = val
            })
        }
        const addonprops = {
            "Adults": "AdultQuantity",
            "Children": "ChildQuantity",
            "Infants": "InfantQuantity"
        }
        if (reservation.ReservationDailyAddons && reservation.ReservationDailyAddons.length > 0) {
            reservation.ReservationDailyAddons.forEach(addon => {
                addon[addonprops[prop]] = val
            })
            //if price type is fixed and the reservation has addons then recalc
            RecalcReservationForFixedPricesPaxChange(reservation, prop, delta);
        }
    }
    const recalcCheckInOutDates = (checkInDate, checkOutDate) => {
        if (checkInDate && reservation.Eta && reservation.Eta.includes(":")) {
            checkInDate.setHours(reservation.Eta.split(":")[0])
            checkInDate.setMinutes(reservation.Eta.split(":")[1])
        }
        if (checkOutDate && reservation.Edt && reservation.Edt.includes(":")) {
            checkOutDate.setHours(reservation.Edt.split(":")[0])
            checkOutDate.setMinutes(reservation.Edt.split(":")[1])
        }
        return {
            checkInDate,
            checkOutDate
        }
    }

    return <Panel header={text("ReservationDetails")} icon="calendar alternate outline">
    <Form>
        <Form.Group unstackable widths="3">
            <DatePicker
                onChange={setCheckInDate}
                label={text("Arrival")}
                minDate={moment(businessDate).startOf("day").toDate()}
                value={moment(reservation.CheckInDate).toDate()} />
            <Form.Field control={TimePicker}
                label={text("ETA")}
                style={{ minWidth: "unset" }}
                width="3"
                value={reservation.Eta}
                onChange={setEta}
            />
            <DatePicker
                onChange={setCheckOutDate}
                label={text("Departure")}
                minDate={reservation.CheckInDate}
                value={moment(reservation.CheckOutDate).toDate()}
                pointing="right" />
            <Form.Field control={TimePicker}
                label={text("ETD")}
                style={{ minWidth: "unset" }}
                width="3"
                value={reservation.Edt}
                onChange={setEdt}
            />
        </Form.Group>
        <Form.Group widths={3} unstackable>
            <Form.Field label={text("Adults")} control={NumericInput} digits={0} buttonPlacement="right" value={String(reservation.Adults)} min={0} max={100} onChange={setAdults} />
            <Form.Field label={text("Children")} control={NumericInput} digits={0} buttonPlacement="right" value={String(reservation.Children)} min={0} max={100} onChange={setChildren} />
            <Form.Field label={text("Infants")} control={NumericInput} digits={0} buttonPlacement="right" value={String(reservation.Infants)} min={0} max={100} onChange={setInfants} />
        </Form.Group>
        <Form.Group widths={2} unstackable>
            <Form.Field label={`${text("Reservation")} ${text("Category")}`} clearable control={ReservationCategoriesDropDown} />
        </Form.Group>
    </Form>
</Panel>
}
DetailsPanel.propTypes = {
    reservation: PropTypes.object
}